import { useMemo } from 'react'
import { useAppParamsContext } from '../../context/AppParamsContext'
import { getThemeFeatureConfig } from '../../constants/appThemeNameConfig'

/**
 * Hook để lấy cấu hình (config) theo theme hiện tại cho một feature cụ thể.
 * Tự động lấy appThemeName từ AppParamsContext.
 * @param {string} featureKey - Tên tính năng (ví dụ: 'RESULT_CRIMINAL_CARD')
 * @returns {Object} Object chứa các thuộc tính config của feature đó
 */
export default function useThemeFeatureConfig(featureKey) {
  const { appThemeName } = useAppParamsContext()

  return useMemo(
    () => getThemeFeatureConfig(appThemeName, featureKey),
    [appThemeName, featureKey]
  )
}
